"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _TableModule = _interopRequireDefault(require("../Table.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DataTableRow = function DataTableRow(_ref) {
  var _columns$, _columns$2;
  var value0 = _ref.value0,
    copy = _ref.copy,
    columns = _ref.columns;
  var hasValuesInColumns1And2 = ((_columns$ = columns[1]) === null || _columns$ === void 0 ? void 0 : _columns$.value) && ((_columns$2 = columns[2]) === null || _columns$2 === void 0 ? void 0 : _columns$2.value);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("tr", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("td", {
      className: _TableModule["default"].firstColumn,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
        children: value0
      }), copy && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: copy
      })]
    }), hasValuesInColumns1And2 ? columns.map(function (column, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
        className: (0, _classnames["default"])(_TableModule["default"].column),
        children: column.value && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: column.value
        })
      }, index);
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
      colSpan: 3,
      className: (0, _classnames["default"])(_TableModule["default"].column, _TableModule["default"].singleCell),
      children: columns[0].value && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: columns[0].value
      })
    })]
  });
};
var _default = exports["default"] = DataTableRow;